import { useTranslation } from 'react-i18next';
import type { UseTranslationResponse } from 'react-i18next';

export const keyPrefix = 'sourceGroupStreams';
export const useSourceGroupStreamsTranslation = (): UseTranslationResponse<'widgets', typeof keyPrefix> => useTranslation('widgets', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    title: 'Источники в группе',
    stream_count: 'Источников: {{count}}',
    in_work_count: '(В работе: {{count}})',
    empty: 'Нет ни одного источника. Добавьте новый или перенесите источники из других групп.',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    title: 'Sources in the group',
    stream_count: 'Sources: {{count}}',
    in_work_count: '(Working: {{count}})',
    empty: 'There are no sources. Add a new one or move sources from other groups.',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    title: 'Fuentes del grupo',
    stream_count: 'Fuentes: {{count}}',
    in_work_count: '(En trabajo: {{count}})',
    empty: 'No hay fuentes. Añade una nueva o mueve fuentes de otros grupos.',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    title: 'Fontes do grupo',
    stream_count: 'Fontes: {{count}}',
    in_work_count: '(Em trabalho: {{count}})',
    empty: 'Não há fontes. Adicione uma nova ou mova fontes de outros grupos.',
  },
}) as Record<string, unknown>;
